<template>
  <AdminForm :config="config" :form="form" :isBusy="isBusy" :options="options"></AdminForm>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";

export default {
  name: "CompanyContactForm",
  components: {
    AdminForm
  },
  props: ["id_to_edit"],
  data() {
    return {
      config: config,
      form: {
        company_id: null
      },
      isBusy: false
    };
  },
  computed: {
    options: function() {
      return {
        company_id_options: this.$store.getters["company/getAll"].selectOptions(
          "id",
          "name"
        )
      };
    }
  },
  mounted() {
    // Edition
    const id =
      this.$route.name == config.editRouteName && this.$route.params.id
        ? this.$route.params.id
        : this.id_to_edit || null;

    if (id) {
      this.isBusy = true;
      this.$store
        .dispatch(config.storeNamespace + "/getItem", {
          id: id,
          wait: true
        })
        .then(() => {
          let item = _.cloneDeep(
            this.$store.getters[config.storeNamespace + "/getItem"](id)
          );
          this.form = {
            ...item,
            company_id: item.company ? item.company.id : null
          };
          this.isBusy = false;
        });
    }

    this.$store.dispatch("company/getAllForSelect");
  }
};
</script>


// WEBPACK FOOTER //
// src/components/CompanyContact/CompanyContactForm.vue